export const environment = {
  production: false,
  apiUrl: 'https://apidev.somosredal.app.br',
  siteUrl: 'https://somosredal.app.br',
  siteName: 'REDAL',
  defaultImage: 'https://somosredal.com.br/redal_logo.png',
  skipAuth: false,
  jwtSecretKeyApp: 'AZW.jm9ZRaxLuBbdsySxUQHeN+lG1tr0xKcMI0qepulCkXWFUeK6jfdM3LwhVpAh5Rzv8mTy1nZnTWOr&T0s',

  socialMedia: {
    instagram: 'https://www.instagram.com/somosredal/',
    website: 'https://somosredal.com.br/',
  },
};
